import { render, staticRenderFns } from "./ListadoWallet.vue?vue&type=template&id=3b5ed9db&"
import script from "./ListadoWallet.vue?vue&type=script&lang=js&"
export * from "./ListadoWallet.vue?vue&type=script&lang=js&"
import style0 from "./ListadoWallet.vue?vue&type=style&index=0&id=3b5ed9db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports